import { TagsUtils, TagsV2 } from '@frontend/api-tag';
import { useAppScopeStore } from '@frontend/scope';

type UseSortedTagsByIdProps = {
  orgId?: string;
  locationIds: string[];
  tagIds: string[];
  enabled?: boolean;
};

export const useGetSortedTagsById = ({ orgId, locationIds, tagIds, enabled }: UseSortedTagsByIdProps) => {
  const { selectedOrgId } = useAppScopeStore();

  const resolvedOrgId = orgId || selectedOrgId;

  const { data: sortedTags } = TagsV2.Queries.useListTagsQuery({
    request: { orgId: resolvedOrgId, groupIds: locationIds },
    options: {
      enabled: enabled && !!resolvedOrgId && locationIds.length > 0,
      select: (data) => TagsUtils.sortTagsAlphabetically(data.tags.filter((tag) => tagIds.includes(tag.id))),
    },
  });

  return sortedTags ?? [];
};
